import React from "react";
import PasswordResetForm from "components/authentication/PasswordResetForm";
import { Card, Col, Row } from "react-bootstrap";
import logo from "assets/img/logos/logoNew.png";
const PasswordReset = () => (
  <div className="text-center overflow-hidden">
    {/* <h5>Reset password</h5> */}
    <Row className="flex-center py-6" style={{ height: "90vh" }}>
      <Col sm={10} md={8} lg={6} xl={5} style={{ width: "395px" }}>
        <Card
          style={{
            borderRadius: "5px",
            // boxShadow: "0px 4px 23px rgba(0, 0, 0, 0.14)",
          }}
          className="border"
        >
          <div className="d-flex justify-content-center mt-2">
            {/* <img
              src={logo}
              alt="Logo"
              width={50}
              style={{ marginLeft: "2px" }}
            /> */}
            <h5 className="pt-2">Change Password</h5>
          </div>
          <Card.Body className="px-4 pb-4 pt-2 px-sm-4 pb-sm-4 pt-sm-2">
            <PasswordResetForm />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </div>
);

export default PasswordReset;
